export default "__VITE_ASSET__7a86eb3b__"